import { moveSelection, type TNodeEntry, unwrapNodes } from '@udecode/plate'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { isSelectionAtEndOfCurrentNode } from '~publish/legacy/editor/queries/isSelectionAtEndOfNode'
import type { AutocompleteInputElement } from '../nodes/AutocompleteInputElement'

export const onMentionUpdated = (
  editor: BufferEditor,
  mentionEntry: TNodeEntry<AutocompleteInputElement>,
  input?: string,
): void => {
  const [node, path] = mentionEntry
  const { autocompleted, valid, data } = node

  if (valid && autocompleted && data) {
    const isAtTheEnd = isSelectionAtEndOfCurrentNode(editor, mentionEntry)

    // If we are at the end of mention
    // make sure a characters is inserted after the mention
    // eg. adding a dot after Jakub Olek. should not remove the mention
    // but also the dot should not be part of the mention
    if (isAtTheEnd && input) {
      moveSelection(editor, { distance: 1, unit: 'offset' })
    } else {
      unwrapNodes(editor, {
        at: path,
      })
    }
  } else {
    if (input === ' ') {
      const { text } = mentionEntry[0].children[0]
      const whitespaceCount = text.match(/ /g)?.length || 0

      if (whitespaceCount > 0) {
        moveSelection(editor, { distance: 1, unit: 'offset' })
      }
    }
  }
}
